import { saveAs } from 'file-saver';
import moment from 'moment';
import { combineReducers } from 'redux';
import Cookies from 'universal-cookie';

import SaleTypes from './types';

import type IMySalesFilter from 'interfaces/IMySalesFilter';

export enum enSaleActions {
  unMountSales = 'UNMOUNTING_SALES',
  mountSales = 'MOUNTING_SALES',
}

const filters: IMySalesFilter = {
  context_filter: 'all',
  payment_method: [],
  payment_status: [],
  period: [moment(new Date()).subtract(7, 'days').format('DD/MM/YYYY'), moment(new Date()).format('DD/MM/YYYY')],
  used_date: 'create',
  affiliates: [],
  main_products: undefined,
  all_variations: [],
  variations: [],
  coupons: [],
  status: [],
  invoices: [],
  utms: [],
  types_gain: [],
  types_charging: [],
  sale_from: undefined,
  customer_name: undefined,
  customer_email: undefined,
  customer_cpfCnpj: undefined,
  contracts: [],
};

export const oldFilters = (state = filters, action: any) => {
  const cookies = new Cookies();

  switch (action.type) {
    case enSaleActions.unMountSales:
      let cooking = action.filters;
      cookies.set('salesfilter', cooking);
      return { ...cooking };
    case enSaleActions.mountSales:
      let cooked = JSON.parse(cookies.get('salesfilter'));
      return { ...state, ...cooked };
    default:
      return state;
  }
};

const exportToCsv = (actionName: string, initialState: any, request: String, success: String, error: String) => {
  return (state = initialState ? initialState : {}, action: any) => {
    switch (action.type) {
      case request:
        return { ...state, isFetching: true };
      case success:
        let dateExport = moment(new Date()).format('DD-MM-YYYY');
        let fileExport = new Blob([action.payload], { type: 'text/csv; charset=utf-8' });
        saveAs(fileExport, `minhas-vendas-${dateExport}.csv`);
        return { ...state, isFetching: false };
      case error:
        return { ...state, isFetching: false };
      default:
        return state;
    }
  };
};

export const saleReducer = combineReducers({
  list: SaleTypes.list.getReducer(),
  oldFilters,
  export: SaleTypes.export.createReducer(exportToCsv),
  backgroundReport: SaleTypes.backgroundReport.getReducer(),
});
